import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'agentesReasig'
})
export class AgentesReasigPipe implements PipeTransform {

  transform(arreglo: any[], texto: string): any[] {
    // console.log(texto);
    if(!texto){
      return arreglo;
    }

    if( arreglo.length === 0 ) {
      return arreglo;
    }
    texto = texto.toLocaleLowerCase();

    return arreglo.filter( item => {
      return item.nombre.toLowerCase().includes(texto) || item.apellido.toLowerCase().includes(texto) || item.usuario.toLowerCase().includes(texto);
    });
    // return arreglo;
  }

}
